{
  "validation-errors": {
    "min-length": "Мінімальна довжина має бути не менше 2",
    "max-length": "Максимальна довжина має бути не більше 50"
  },

  "steps": {
    "title": "Дослідження {{name}}",
    "button": {
      "results": "Дивитись результати"
    }
  },

  "step": {
    "title": "Етап {{index}}",
    "button": {
      "start": "Розпочати",
      "finish": "Завершити"
    }
  },

  "create-step": {
    "title": "Новий етап",
    "trigger": "+ Створити етап"
  },

  "create-new-step-dialog": {
    "title": "Вкажіть назву для нового етапу",
    "close": "Відмінити",
    "placeholder": "Назва",
    "button": {
      "create": "Створити новий етап",
      "loading": "Створюємо"
    }
  },

  "results": {
    "steps-linear-chart": {
      "title": "Залученість учасників за етапами",
      "empty-state": "Для відображення графіка потрібно завершити щонайменше 1 етап",
      "side-label": "Учасники"
    },
    "score-card": {
      "title": "Залученість",
      "description": "Кількість учасників, що завершили всі етапи дослідження",
      "get-results-button": "Отримати результати"
    },

    "linear-chart-by-scale-and-survey-type": {
      "title": "Динаміка стану",
      "empty-state": "Оберіть шкали для порівняння",
      "multi-select-trigger": "Шкали",
      "how-to-read-tooltip": {
        "trigger": "Як читати графік",
        "content": "- Можна обрати до 5 шкал, щоб подивитись їхню динаміку за етапами. \n - Кожна точка відображає середнє значення на етапі \n - Звертайте увагу на кількість учасників: менше учасників — менше даних, а значить менш точна оцінка стану групи."
      }
    },

    "scales": {
      "title": "Шкали опитувальника"
    },
    "participants-involvement-table": {
      "title": "Залученість учасників",
      "empty-state": "Немає даних",
      "status": {
        "pending": "Очікується"
      }
    }
  }
}
